<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Response from '@/router/views/master/rfid-facerecognition/upload/response'
import McButton from '@/components/McButton'
import McGrapqlTable from '@/components/McGrapqlTable'
import { Helper } from '@/mixin/helper'
import {
  IMPORT_IDENTIFICATION,
  IMPORT_IDENTIFICATION_TEMPLATE,
  IMPORT_HISTORY,
} from '@/services/api/master/rfid-facerecognition'

export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Response,
    McButton,
    McGrapqlTable,
  },
  mixins: [Helper],
  data() {
    return {
      value: '',
      file: null,
      fileProp: {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      },
      showRemovedBtn: false,
      importResponse: false,
      responseData: {
        totalFailed: null,
        totalSuccess: null,
        totalData: null,
        errorFile: null,
        fileName: null,
        fileType: null,
      },
      refreshTable: false,
    }
  },
  computed: {
    title() {
      return this.$t('global.action.upload')
    },
    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
          to: '/master',
        },
        {
          text: this.$t('rfidAndFacerecognition.title'),
          to: '/master/identification',
        },
        {
          text: this.$t('global.action.upload'),
        },
      ]
    },
    historyUpload() {
      return [
        {
          key: 'importOn',
          label: this.$t('global.importHistory.time'),
          isSortable: true,
        },
        {
          key: 'filename',
          label: this.$t('global.importHistory.file'),
          isSortable: true,
        },
        {
          key: 'status',
          label: this.$t('global.importHistory.status'),
        },
        {
          key: 'users.fullname',
          label: this.$t('global.importHistory.uploadBy'),
          isSortable: true,
        },
      ]
    },
    query() {
      return {
        get: async (opts) => {
          const res = await this.$apollo.query({
            query: IMPORT_HISTORY,
            variables: {
              filter: {
                model: 'identification',
                orderBy: opts.sorts || [JSON.stringify({ importOn: 'desc' })],
                search: opts.search,
              },
            },
            fetchPolicy: 'no-cache',
          })

          const data = res.data.importHistory.importHistory
          return {
            data: data,
            pagination: {
              page: opts.pagination.page,
              show: opts.pagination.show,
              total: data.length,
            },
          }
        },
      }
    },
  },
  methods: {
    directTo() {
      this.$bvModal.hide('modal-template-download')
    },
    async downloadTemplate() {
      try {
        const response = await this.$apollo.query({
          query: IMPORT_IDENTIFICATION_TEMPLATE,
        })
        if (response.data.importIdentificationTemplate.isSuccessful) {
          const base64 =
            response.data.importIdentificationTemplate.importIdentificationTemplate.base64
          const temp =
            'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
            base64
          const download = document.createElement('a')
          download.href = temp
          download.download = 'Template_Identifikasi.xlsx'
          document.body.appendChild(download)
          download.click()
          document.body.removeChild(download)
          this.$bvModal.hide('modal-template-download')
        } else {
          this.$mcToast.warning(response.data.importIdentificationTemplate.message)
        }
      } catch (error) {
        this.$mcToast.error(this.$t('global.alert.text.templateDownloadFailed'))
      }
    },
    refreshData() {
      this.refreshTable = true
      this.$nextTick(() => {
        this.refreshTable = false
      })
    },
    async fileChangeHandler(e) {
      const files = e.target.files
      if (files.length == 0) return
      this.file = files[0]
      this.fileProp.name = files[0].name
      this.fileProp.size = (files[0].size / (1024 * 1024)).toFixed(2)

      const input = {
        filebase64: null,
        filename: files[0].name,
      }

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })

      input.filebase64 = (await toBase64(files[0])).split(',')[1]

      if (
        files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        files[0].type === 'text/csv'
      ) {
        if (this.fileProp.size > 10) {
          this.fileProp.message = this.$t('license.text.tooLarge')
          this.fileProp.error = true
          return
        }
        this.fileProp.error = false
        this.showRemovedBtn = true

        const param = [15, 25, 50, 70, 90, 100]
        for (let i = 0; i < param.length; i++) {
          setTimeout(() => {
            this.fileProp.sizeProgress = ((this.fileProp.size * param[i]) / 100).toFixed(2)
            this.fileProp.progressVal = param[i]
            if (param[i] === 100) {
              setTimeout(() => {
                this.$apollo
                  .mutate({
                    mutation: IMPORT_IDENTIFICATION,
                    variables: {
                      input: input,
                    },
                  })
                  .then((response) => {
                    if (response.data.importIdentification.isSuccessful) {
                      this.importResponse = true
                      const importData = response.data.importIdentification.importIdentification
                      this.responseData.totalData = importData?.totalData || 0
                      this.responseData.totalFailed = importData?.totalFailed || 0
                      this.responseData.totalSuccess = importData?.totalSuccess || 0
                      this.responseData.errorFile = importData?.errorFile || null
                      this.responseData.fileName = files[0].name
                      this.responseData.fileType = files[0].type
                    } else {
                      if (
                        response.data.importIdentification.message ==
                        'Error: "Incorrect File Used."'
                      ) {
                        this.fileProp.message = this.$t('license.text.template')
                        this.fileProp.error = true
                      } else {
                        return this.$mcToast.warning(response.data.importIdentification.message)
                      }
                    }
                  })
              }, 1000)
            }
          }, i * 500)
        }
      } else {
        this.fileProp.message = this.$t('license.text.incompatible')
        this.fileProp.error = true
      }
    },
    deleteFile() {
      this.importResponse = false
      this.file = null
      this.fileProp = {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p class="mb-4">Halaman unggah data RFID dan Pengenalan Wajah</p>
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            v-b-modal.modal-history-upload
            data-me="master-fr-import-btn-history-upload"
            variant="secondary"
            class="ms-3"
            icon="icon-outline_file-text"
            :text="$t('global.importResult.historyUpload')"
            @click="refreshData"
          />
          <McButton
            v-if="importResponse"
            data-me="master-fr-import-btn-upload-again"
            variant="primary"
            class="ms-2"
            icon="icon-outline_upload"
            :text="$t('global.importResult.uploadAgain')"
            @click="deleteFile"
          />
          <McButton
            data-me="master-fr-import-btn-back"
            variant="secondary"
            class="ms-3"
            icon="icon-outline_arrow-left"
            :text="$t('global.back')"
            @click="$router.push({ name: 'Master RFID and Face Recognition' })"
          />
        </div>
      </div>
    </div>

    <div v-if="importResponse" class="card">
      <div class="card-body">
        <Response
          :totalFailed="responseData.totalFailed"
          :totalSuccess="responseData.totalSuccess"
          :totalData="responseData.totalData"
          :errorFile="responseData.errorFile"
          :fileName="responseData.fileName"
          :fileType="responseData.fileType"
        />
        <p></p>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="mc-upload d-flex justify-content-between">
          <div class="mc-upload__file">
            <div class="mc-upload__file-wrapper">
              <div v-if="fileProp.name == null" class="mc-upload__file-area">
                <input
                  id="inputfile"
                  ref="inputfile"
                  type="file"
                  name="attachment"
                  class="mc-upload__file-area-input"
                  accept=".xlsx, .csv"
                  data-me="master-fr-import-input-file"
                  @change="fileChangeHandler"
                  @drop="fileChangeHandler"
                />

                <div class="mc-upload__file-area-text">
                  <i class="mc-fa icon-outline_upload"></i>
                  <p>{{ $t('global.importData.chooseFile') }}</p>
                  <p>{{ $t('global.importData.maksFile') }}</p>
                </div>
              </div>

              <div
                v-else
                :class="`mc-upload__file-result ${
                  fileProp.error ? 'mc-upload__file-result--error' : null
                }`"
              >
                <div class="mc-upload__file-result-wrapper">
                  <i class="mc-fa icon-outline_file"></i>
                  <h4 class="mc-upload__file-result-status">
                    {{ fileProp.message }}
                  </h4>
                  <div class="mc-upload__file-result-desc d-flex justify-content-between">
                    <span>{{ fileProp.name }}</span>
                    <span v-if="fileProp.error">
                      <!-- <i class="mc-fa icon-outline_refresh"></i> -->
                      <i class="mc-fa icon-outline_trash-2" @click="deleteFile"></i>
                      <i class="mc-fa icon-fill_alert-triangle"></i>
                    </span>
                  </div>
                  <div class="mc-upload__file-result-progress">
                    <div :style="`width: ${fileProp.progressVal}%`"></div>
                  </div>
                  <span class="mc-upload__file-result-filesize">
                    <span>{{ fileProp.sizeProgress }} MB / </span>{{ fileProp.size }} MB
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="mc-upload__info">
            <div class="mc-upload__info-wrapper">
              <h3 class="mc-upload__info-title">
                <i class="mc-fa icon-outline_book"></i> {{ $t('global.importData.guide') }}
              </h3>
              <ul class="mc-upload__info-list">
                <li>
                  <strong> {{ $t('global.importData.downloadTemplate') }}</strong>
                  <p>
                    {{ $t('global.importData.downloadDesc') }}
                  </p>
                  <McButton
                    v-b-modal.modal-template-download
                    data-me="master-fr-import-btn-download-template-trigger"
                    icon="icon-outline_download"
                    :text="$t('global.importData.downloadTemplate')"
                    variant="primary"
                    size="sm"
                  />
                </li>
                <li>
                  <strong> {{ $t('global.importData.copyData') }}</strong>
                  <p>
                    {{ $t('global.importData.copyDesc') }}
                  </p>
                </li>
                <li>
                  <strong> {{ $t('global.importData.upload') }}</strong>
                  <p>
                    {{ $t('global.importData.uploadDesc1') }}
                    <b>.csv</b> {{ $t('global.object.to') }} <b>.xlsx</b>.
                    {{ $t('global.importData.uploadDesc2') }}
                  </p>
                </li>
                <li>
                  <strong>{{ $t('global.object.note') }}</strong>
                  <p>
                    Unggah data disini hanya berlaku untuk menugaskan beberapa pengemudi ke dalam
                    beberapa kendaraan sekaligus dalam satu kali upload
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-history-upload"
      class="mc-modal"
      :title="$t('global.importResult.historyUpload')"
      size="lg"
      centered
      scrollable
    >
      <McGrapqlTable
        :apiClient="query"
        :fields="historyUpload"
        :hasCheckbox="false"
        :searchable="true"
        :refreshData="refreshTable"
        trackBy="importOn"
        clientSidePagination
      >
        <template #cell(importOn)="row">
          <p class="my-0">
            {{ momentDateShortMonth(row.value) }}
          </p>
          <p class="text-muted my-0">{{ momentTime(row.value) }}</p>
        </template>
        <template #cell(status)="data">
          <span v-if="data.item.totalFailed === 0" class="mc-status mc-status--green">
            {{ $t('global.success') }}
          </span>
          <span v-else-if="data.item.totalSuccess === 0" class="mc-status mc-status--red">
            {{ $t('global.failed') }}
          </span>
          <span
            v-else-if="data.item.totalSuccess > 0 && data.item.totalFailed > 0"
            class="mc-status mc-status--yellow"
          >
            {{ $t('global.importResult.partialSuccess') }}
          </span>
        </template>
      </McGrapqlTable>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="text-end">
            <McButton
              data-me="master-fr-import-modal-history-btn-close"
              variant="secondary"
              :text="$t('global.action.close')"
              @click="cancel()"
            />
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-modal
      id="modal-template-download"
      class="mc-modal"
      :title="$t('global.importData.downloadTemplate')"
      size="md"
      centered
      scrollable
      modal-class="mc-modal-import"
      data-me="master-fr-import-modal-template"
    >
      <p class="mc-modal-text">
        {{ $t('global.importData.templateDesc') }}
      </p>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="text-end">
            <McButton
              data-me="master-fr-import-modal-template-btn-close"
              variant="secondary"
              icon="close"
              :text="$t('global.action.close')"
              @click="cancel()"
            />
            <McButton
              data-me="master-fr-import-modal-template-btn-download"
              variant="primary"
              icon="icon-outline_download"
              text="Template & Data"
              class="ms-2"
              @click="downloadTemplate()"
            />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
